import { colors } from '../../../../../colorVars';
import style from './ColorLetterBox.module.css';
const titleMap = {
  A: 'Armed',
  P: 'Paused',
  D: 'Deactivated',
  E: 'Entered',
};
type Props = {
  backgroundColor: string;
  width: string;
  height: string;
  margin: string;
  letter: string;
  fontSize: string;
  selected?: boolean;
};

export const ColorLetterBox = ({
  backgroundColor,
  width,
  height,
  margin,
  letter,
  fontSize,
  selected,
}: Props) => {
  return (
    <div
      title={titleMap[letter]}
      className={style.div}
      style={{
        backgroundColor,
        width,
        height,
        margin,
        fontSize,
        borderColor: selected ? colors.yellow : colors.lightGrey,
        // color: selected ? colors.yellow : colors.lightGrey,
      }}
    >
      <span>{letter}</span>
    </div>
  );
};
